import { RegraPercentualResgate } from '../../enum/parametros/regra-percentual-resgate.enum';
import { FormaPagamentoResgate } from '../../enum/parametros/forma-pagamento-resgate.enum';
import { IntervaloParcelamento } from '../../enum/parametros/intervalo-parcelamento.enum';
import { ResgateConfiguracao } from '../../models/parametros/resgate-configuracao.model';
import { FilterFieldOption } from '../../../shared/components/filter-bar/filter-bar.component';

export const PARCELAS_MINIMO = 1;

/**
 * Valores de um plano sem configuração cadastrada. A vigência começa em branco porque depende do
 * plano.
 */
export const RESGATE_CONFIGURACAO_PADRAO: ResgateConfiguracao = {
  status: 'Ativo',
  vigencia: { inicio: '', fim: null },
  descricao: '',
  percentual: { regra: RegraPercentualResgate.Total },
  tributacao: { irRegressivo: true, irProgressivo: true },
  pagamento: {
    forma: FormaPagamentoResgate.Parcelado,
    parcelasMinimas: 1,
    parcelasMaximas: 12,
    intervalo: IntervaloParcelamento.MensalAntecipacao,
  },
  /** Os documentos vêm do catálogo `/v1/tipos-documento`: o plano novo começa sem nenhum. */
  documentos: [],
  retencao: { valorMinimo: 100, valorMaximo: 10000 },
  assinatura: {
    obrigatoria: true,
    provedor: '',
    validacaoDuasEtapas: true,
  },
};

export const INTERVALO_PARCELAMENTO_OPCOES: readonly FilterFieldOption[] = [
  { value: IntervaloParcelamento.Mensal, label: 'Mensal' },
  { value: IntervaloParcelamento.MensalAntecipacao, label: 'Mensal e antecipação' },
];

export const FORMA_PAGAMENTO_OPCOES: readonly FilterFieldOption[] = [
  { value: FormaPagamentoResgate.Unico, label: 'Pagamento único' },
  { value: FormaPagamentoResgate.Parcelado, label: 'Parcelamento' },
];

export const STATUS_CONFIGURACAO_OPCOES: readonly FilterFieldOption[] = [
  { value: 'Ativo', label: 'Ativo' },
  { value: 'Inativo', label: 'Inativo' },
];

/** Limite de caracteres da descrição do resgate (DS_RESGATE). */
export const DESCRICAO_MAXIMO = 500;

export const REGRA_PERCENTUAL_OPCOES: readonly FilterFieldOption[] = [
  { value: RegraPercentualResgate.Total, label: 'Resgate total' },
  { value: RegraPercentualResgate.Parcial, label: 'Resgate parcial' },
];
